import { Form } from '../core'

$.fn.NewsletterForm = function() {
  let self = this
  self.section = self.closest('.text-content')
  self.form = undefined

  self.initialize_form = function() {
    self.find('.field-container--email_address').after(self.find('.field-container--recaptcha'))
    self.form = new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: true,
      onSubmit: function() {
        $('.form-success').slideUp(function() {
          $(this).remove();
        })
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
        let $success = $('<p class="form-success form-success--newsletter text-intro-inter">')
        $success.text(visagesregionaux_l10n.NEWSLETTER_SENT).hide()
        self.section.css('height', self.section.outerHeight(false) + 'px')
        self.after($success.fadeIn(250))
        self.remove()
      })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('newsletter-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
